import classNames from 'classnames';
import * as React from 'react';

type Props = {
  open: boolean;
  toggleMenu: () => void;
};

export class MenuButton extends React.PureComponent<Props> {
  public render() {
    const { open, toggleMenu } = this.props;

    return (
      <button
        className={classNames('menu-button', { 'menu-button--open': open })}
        onClick={toggleMenu}
      >
        <span>Menu</span>
      </button>
    );
  }
}
